module.exports = __webpack_public_path__ + "static/foreground-c6a130c0a9cc284d4133335abbe0cce2.png";